// extracted by mini-css-extract-plugin
module.exports = {"menuHamburger":"styles_menuHamburger__CmwSz","menuHamburger__expanded":"styles_menuHamburger__expanded__fOFqF"};